import React from 'react';

export default function Navbar() {
    return (
        <>
            <nav className=" bg-black p-4">
                <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
                    <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
                        <h1
                            className="text-lg leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-white"
                        >
                            Dashboard App
                        </h1>
                    </div>
                </div>
            </nav>
        </>
    );
}